import {
  WSActions,
  WSCard,
  WSEmptyState,
  WSList
} from "@wingspanhq/fe-component-library";
import { EditPayeeSetupParams } from "./index";
import { SetupRouteComponentProps } from "../../../../shared/components/FlowSetup";
import React from "react";
import { TinType } from "@wingspanhq/payments/dist/interfaces";

type Props = SetupRouteComponentProps<EditPayeeSetupParams>;

export const EditPayeeTaxInfoVerificationSuccess: React.FC<Props> = ({
  onNext,
  params
}) => {
  const tinType = params?.payee?.payerOwnedData.payeeW9Data.tinType;
  const tinTypeLabel = tinType === TinType.Individual ? "SSN" : "EIN";

  return (
    <WSList gap="2XL">
      <WSCard>
        <WSEmptyState
          type="done"
          title={`Contractor’s ${tinTypeLabel} was verified`}
          description={`The IRS has confirmed the contractor’s ${tinTypeLabel}. Once verified, the tax information provided cannot be edited without re-verification. Click continue for the next step`}
          orientation="horizontal"
        />
      </WSCard>
      <WSActions
        alignment="fill"
        buttons={[
          {
            label: "Continue",
            onClick: onNext
          }
        ]}
      />
    </WSList>
  );
};
